import frontPage from "../../assets/images/inicio/revista adiac.png";
// import download from "../../assets/images/inicio/icono descarga.png";
import "./DownDoc.css";
import { Link } from "react-router-dom";
const DownDoc = () => {
  return (
    <div className="doc-content">
      <div className="doc-left-column">
        <div className="text-doc">
          Catalogo de pesos y Medidas ADIAC NOROESTE
          <div className="buttons">
            {/* <button>
              <img src={download} alt="Flecha Izquierda" loading="lazy" />
              PDF
            </button> */}
            <Link
              onClick={() => window.scrollTo(0, 0)}
              to="/catalogo"
              className="read-catalogo"
            >
              Ver catálogo
            </Link>
          </div>
        </div>
      </div>
      <div className="doc-right-column">
        <img src={frontPage} alt="Catálogo ADIAC" loading="lazy" />
      </div>
    </div>
  );
};

export default DownDoc;
